import { useEffect } from 'react';
import { PUSHER_STATES } from '@/context/PusherContext/PusherContextConstants';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';
import { showErrorToast, showSuccessToast } from '@/libs/toast/toast';
import { onCaptionsTranslated, updateClipTranslationLoadingState } from '@/stores/clip';

export const useSubscribeToTranslateNotification = ({ onDone }: { onDone?: (clipId: string) => void }) => {
  useEffect(() => {
    const eventHandler = (data: { id: string; state: string; title: string }) => {
      if (data.state === PUSHER_STATES.CAPTION_TRANSLATION_DONE) {
        showSuccessToast(`Translation of ${data.title} is completed`);
        onCaptionsTranslated(data.id);
        onDone?.(data.id);
      } else if (data.state === PUSHER_STATES.CAPTION_TRANSLATION_FAILED) {
        updateClipTranslationLoadingState(data.id, false);
        showErrorToast('Translation failed. Please try again.');
      }
    };

    const listener = EventBus.on(CustomEvents.CaptionTranslationStatusUpdated, eventHandler);

    return () => {
      EventBus.off(CustomEvents.CaptionTranslationStatusUpdated, listener);
    };
  }, [onDone]);
};
